import { breakdanceStoreActions } from "@/store/actions/store-actions";
import { aiJobController } from "./ai-jobs";
import { documentStore } from "@/store/store";
import { findNode } from "@/lib/tree/tree";
import { SECTION_SLUG } from "@/lib/elements/constants";
import { inlineEditorActions } from "@/lib/inline-editor/actions-api";

export function registerAIJobManagerActions() {
  // Cancel AI jobs when a section element is deleted
  breakdanceStoreActions.register.onBeforeDeletingElement(({ elementId }) => {
    const element = findNode(documentStore.document.tree, elementId);
    if (!element) return;
    if (element.data.type !== SECTION_SLUG) return;

    aiJobController.cancelJobsMatching({
      jobType: "section_rewrite",
      elementId: elementId
    });

    aiJobController.cancelJobsMatching({
      jobType: "section_image_replacement",
      elementId: elementId
    });
  });

  // Cancel AI jobs when inline editor is closing (sections being deleted)
  inlineEditorActions.register.onBeforeClosingInlineEditor(({ childrenIds }) => {
    childrenIds.forEach(childId => {
      aiJobController.cancelJobsMatching({
        elementId: childId
      });
    });
  });
}
